import gql from 'graphql-tag'

export const STOREFRONT_FEEDBACK_CREATE_MUTATION = gql`
    mutation storefrontFeedbackCreateMutation(
        $storefrontFeedbackCreateInput: StorefrontFeedbackCreateInput!
    ) {
        storefrontFeedbackCreate(input: $storefrontFeedbackCreateInput) {
            userErrors {
                message
            }
        }
    }
`

export const ORDER_FEEDBACK_CREATE_MUTATION = gql`
    mutation orderFeedbackCreateMutation(
        $orderFeedbackCreateInput: OrderFeedbackCreateInput!
    ) {
        orderFeedbackCreate(input: $orderFeedbackCreateInput) {
            userErrors {
                message
            }
        }
    }
`
